export default __webpack_public_path__ + "static/media/note-icon.f1f396a7.svg";